<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol>
        <meta-section>
          <div class="text-right d-flex flex-row gap-2">
            <ArgonButton
              :to="{ name: 'User' }"
              isRouteLink
              outline
            >
              Kembali</ArgonButton
            >
            <ArgonButton
              :to="{ name: 'Edit User', params: { id: this.$route.params.id } }"
              isRouteLink
            >
              Ubah</ArgonButton
            >
          </div>
        </meta-section>
      </GridCol>
      <GridCol>
        <div class="d-flex flex-column gap-4">
          <CardComponent :withmin="false">
            <fieldset-component title="Informasi Pegawai" isFieldsetRow>
              <div class="row">
                <div class="col-md-12">
                  <div style="width: 11.1112vw;height: 11.1112vw;position: relative;margin: 0 auto;">
                    <img v-if="data.employee?.photo!='' && data.employee?.photo != null" :src="data.employee?.photo" alt="Employee" class="img-fluid" style="width: 11.1112vw;height: 11.1112vw;">
                    <img v-else :src="require('@/assets/img/avatar.png')" alt="Default avatar" class="img-fluid" style="width: 11.1112vw;height: 11.1112vw;">
                  </div>
                </div>
              </div>
              <GridRow>
                <div class="col-md">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Nama Lengkap" class="m-0">
                      {{ data.employee?.name ?? "&nbsp;" }}
                    </FormGroup>

                    <FormGroup label="NIP" class="m-0">
                      {{ data.employee?.nip ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Jenis Kelamin" class="m-0">
                      {{ data.employee?.gender ?? "&nbsp;" }}
                    </FormGroup>

                    <FormGroup label="Email" class="m-0">
                      {{ data.email ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Status" class="m-0">
                      <argon-badge v-if="data.is_active == 1" color="success"
                        >Aktif</argon-badge
                      >
                      <argon-badge v-if="data.is_active == 0" color="danger"
                        >Non Aktif</argon-badge
                      >
                    </FormGroup>

                    <FormGroup label="Hak Akses" class="m-0">
                      {{ getHakAkses(data) }}
                    </FormGroup>
                  </div>
                </div>
              </GridRow>
            </fieldset-component>
          </CardComponent>

          <CardComponent :withmin="false">
            <FieldsetComponent title="Informasi Jabatan" isFieldsetRow>
              <GridRow class="row">
                <div class="col-md">
                  <FormGroup label="Jabatan" class="m-0">
                    {{ data.employee?.jabatan?.name ?? "" }}
                  </FormGroup>
                </div>
                <div class="col-md">
                  <FormGroup label="Unit Kerja" class="m-0">
                    {{ data.employee?.unitkerja?.name ?? "" }}
                  </FormGroup>
                </div>
              </GridRow>
            </FieldsetComponent>
          </CardComponent>
        </div>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
import UsersApi from "@/repository/api/UsersApi";
// import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import FieldsetComponent from "../components/FieldsetComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
export default {
  name: "tables",
  components: {
    CardComponent,
    // ThreeDotsMenu,
    FieldsetComponent,
    FormGroup,
    ArgonBadge,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
  },
  data() {
    return {
      timer: undefined,
      data: {},
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    getHakAkses(item) {
      let hakakses = [];

      if ((item.groups ?? []) != []) {
        (item.groups ?? []).forEach(group => {
          hakakses.push(group?.name);
        });
      }


      return hakakses[hakakses.length - 1]
    },
    async getData() {
      this.$store.state.loading = true;
      await UsersApi.get(this.$route.params.id)
        .then((response) => {
          this.data = response.data;
          if (this.data?.employee?.photo && this.data?.employee?.photo != null) {
            this.data.employee.photo = String(process.env.VUE_APP_BASE_API).replace(/\/$/, '') + this.data?.employee?.photo
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      this.$store.state.loading = false;
    },
    getEmployePhoto(path) {
      return "http://localhost:9100" + path;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          this.$store.state.loading = true;
          await UsersApi.delete(id)
            .then(() => {
              this.getData();
              this.$swal({
                icon: "success",
                title: "Berhasil",
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: error.response.data.message,
              });
            });
          this.$store.state.loading = false;
        }
      });
    },
  },
};
</script>
